import React from 'react'

const SlideCreation = () => {
    return (
        <div>
            <h2>SlideCreation</h2>
        </div>
    )
}

export default SlideCreation
